export const PAGE_NAVTITLE_TRANSLATE_ID = 'page_navtitle';
export const PAGE_OBJECT_TYPE = 'Page';
